import script from "./Guitar.vue?vue&type=script&setup=true&lang=js"
export * from "./Guitar.vue?vue&type=script&setup=true&lang=js"

import "./Guitar.vue?vue&type=style&index=0&id=00377372&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00377372"]])

export default __exports__